import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pf } from '../../models/itens.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-itens-ac-pf',
  templateUrl: './itens-ac-pf.component.html',
  styleUrls: ['./itens-ac-pf.component.scss','../itens-edit/itens-edit.component.scss']
})
export class ItensAcPfComponent extends BaseFormComponent<Pf> implements OnInit {
  @Input() parentFormGroup: FormGroup = null;
  @Input() expand: boolean = true;
  @Input() acMeetingType: number;
  @Input() currentItem: object[] = [];
  @Output() checkStatus = new EventEmitter<boolean>();
  constructor(
    public activatedRoute: ActivatedRoute,
  ) { 
    super(activatedRoute);
  }
  ngOnInit() {
    this.acPf?.controls.forEach(item => {
      var pf = item as FormGroup;
      if(this.acMeetingType === 3){
        this.onCheckStatus(pf, false);
      }
    })
    
  }
  
  get acPf(): FormArray {
    return this.parentFormGroup.get('acPf') as FormArray;
  }

  onCheckStatus(itemForm:FormGroup = null,change: boolean = true) {
    if(itemForm != null){
      const anyChecked = itemForm.get('pfIndicators').value.some(it => it.checkeds === true);
      itemForm.get("checkeds").setValue(anyChecked ?? false);
    }
    this.checkStatus.emit(change);
  }

  changeAllCheck(item: FormGroup, status: boolean){
    item.get("checkeds").setValue(status);
    const subArray = item.get('pfIndicators') as FormArray;
    subArray.controls.forEach(it => {
        it.get("checkeds").setValue(status);
    });
    this.onCheckStatus(item);
  }
  
  
  restartCheck(item: FormGroup, i:number){
    var indicatorValue = false;
    var currentValue = this.currentItem[i]['pfIndicators'];
    const indArray = item.get('pfIndicators') as FormArray;
    indArray.controls.forEach(ind => {
      var indicator = currentValue?.find(item => item.id === ind.get("id").value);
      var value = indicator?.meeting_indicator? true : false;
      ind.get("checkeds").reset(value);
      if(value) {
        indicatorValue = true;
      }
    })
    item.get("checkeds").reset(indicatorValue);
    this.onCheckStatus(item);
  }
}
